import React from 'react'
import {EOLocale} from 'eo-locale'

import locales from '../locales'
import {useGatsbyData} from '../context/gatsbyDataContext'
import logo from '../images/logo.svg'
import {Link, ObjectLink} from './Link'
import {nav, lastSuportedReleases} from '../config/site'
import Search from './Search'
import VersionsButton from './Docs/VersionsButton'

import '../styles/styles.scss'
import './Layout.scss'

function NavBar({currentRelease}) {
  return (
    <div className="nav-wrapper">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container">
          <Link className="navbar-brand" hasLocale to="/">
            <img alt="logo" style={{width: 200}} src={logo} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className="navbar-nav ml-auto font-weight-bold">
              {nav.map((link, i) =>
                link.externalLink === true ? (
                  <a
                    key={i}
                    className={
                      'nav-item text-uppercase py-2 px-3 ' +
                      (link.context.includes(currentRelease)
                        ? 'active-location'
                        : '')
                    }
                    href={link.linkTo}
                  >
                    {link.text}
                  </a>
                ) : (
                  <ObjectLink
                    key={i}
                    className={
                      'nav-item text-uppercase py-2 px-3 ' +
                      (link.context.includes(currentRelease)
                        ? 'active-location'
                        : '')
                    }
                    text={link.text}
                    hasLocale={link.hasLocale}
                    linkTo={link.linkTo}
                  />
                ),
              )}
              {lastSuportedReleases.includes(
                useGatsbyData().pageContext.release,
              ) && <VersionsButton />}
              <div className="vl" />
              <ObjectLink
                key="signin"
                className="nav-item text-uppercase py-2 px-3"
                text="SIGN IN"
                linkTo="https://cloud.incorta.com/signin"
              />
              <ObjectLink
                key="signup"
                className="nav-item signup text-uppercase py-2 px-3"
                text="START FOR FREE"
                linkTo="https://cloud.incorta.com/signup"
              />
            </div>
          </div>
        </div>
      </nav>

      {/* search bar */}
      <div className="p-2 pb-3">
        <div className="container">
          <Search />
        </div>
      </div>
    </div>
  )
}

function LayoutComponent({children}) {
  const {locale} = useGatsbyData().pageContext
  return (
    <EOLocale.Provider language={locale} locales={locales}>
      <div style={{minHeight: `calc(100vh - 60px)`}}>
        <NavBar currentRelease={useGatsbyData().pageContext.release} />
        {children}
      </div>

      <footer className="container">
        <div
          className="d-flex justify-content-center align-items-center border-top"
          style={{height: 20}}
        >
          © Incorta, Inc. All Rights Reserved.
        </div>
      </footer>
    </EOLocale.Provider>
  )
}

export default LayoutComponent
